/*
 * @Description:
 * @Date: 2025-02-18 17:00:08
 */
import { DefineComponent } from 'vue';
import { BaseTableColumnProps, XrkTableProps } from 'xrk-components';
import { useSetTableConfig, getColumnsCheckedKey } from './src/hooks/index';
import _BizTableSetField from './src/views/biz-table-set-field.vue';

export type TableColumnsItem = BaseTableColumnProps & {
  _sign: 'base' | 'other'; // 复选框类型
  _sort: number; // 排序
  _checked: 0 | 1; // 是否选中
  _relevance?: string[]; // 如果搜索字段和列表字段中文不一致时用到
  _disabled?: boolean; // 是否禁用
  prop: any; // 字段key
};
export type BizTableSetFieldProps = {
  tableColumns: TableColumnsItem[];
  searchColumns: XrkTableProps['searchConfig']['searchColumns'];
  baseTitle: string; // 基础字段标题
  otherTitle: string; // 其他字段标题
  storeKey: string; // 缓存标识
};

export const BizTableSetField =
  _BizTableSetField as unknown as DefineComponent<BizTableSetFieldProps>;

export { useSetTableConfig, getColumnsCheckedKey };
